import { SITE_LIST } from "@/config/sites";

// Rétablirmoncredit.com (approval) is the only public site — legacy site keys
// remain in config for future revival but always resolve to `approval`.
export function resolveSiteFromHostname() {
  if (typeof window === "undefined") return "approval";
  const host = window.location.hostname.toLowerCase();
  // If a production domain other than retablirmoncredit.com is somehow used,
  // still land the visitor on the main marketplace.
  const found = SITE_LIST.find(
    (s) => host === s.domain || host === `www.${s.domain}` || host.endsWith(`.${s.domain}`),
  );
  if (found && found.key === "approval") return "approval";
  return "approval";
}

export const DEFAULT_SITE = "approval";
